module.exports = __webpack_public_path__ + "img/icon2.76292721.png";